
import Logo from './Logo.vue';

export default {
    name: 'Footer',
    components: {Logo},
    data() {
        return {
            year: new Date().getFullYear(),
            informationLinks: [
                {name: 'Подарочный сертификат', link: '/giftcard/'},
                {name: 'О бренде', link: '/about/'},
                {name: 'Доставка и оплата', link: '/delivery/'},
                {name: 'Возврат и обмен товара', link: '/warranty/'},
                {name: 'Определение размера', link: '/sizes/'},
            ],
            legalLinks: [
                {name: 'Политика обработки персональных данных', link: '/privacy/'},
                {name: 'Договор-оферта', link: '/oferta/'},
                {name: 'Согласие на обработку персональных данных пользователя сайта', link: '/cookie'},
                {name: 'Политика конфиденциальности', link: '/policy'},
            ],
        };
    },
    computed: {
        email() {
            return this.$config.siteCountry === 'kz' ? 'info@sevensix.kz' : 'info@sevensix.sport';
        },
        phoneNumber() {
            return this.$config.siteCountry === 'kz' ? '+77077750076' : '+78001019675';
        },
        phoneLabel() {
            return this.$config.siteCountry === 'kz' ? '+7 707 775 0076' : '8 (800) 101-96-75';
        },
    },
}
